// extracted by mini-css-extract-plugin
module.exports = {"left":"PageNotFound-module--left--2TzmU","title":"PageNotFound-module--title--288Sd","image":"PageNotFound-module--image--TLwmI"};